var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export var MessageType;
(function (MessageType) {
    MessageType["success"] = "success";
    MessageType["error"] = "error";
})(MessageType || (MessageType = {}));
var Context = React.createContext([null, function () { }]);
Context.displayName = 'FlashMessage.Context';
var loadHistoryContextKey = function () {
    var _a;
    var state = history.state;
    if (state === null || typeof state !== 'object') {
        return null;
    }
    return (_a = state.flashMessageContextKey) !== null && _a !== void 0 ? _a : null;
};
export var FlashMessageProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(null), message = _b[0], setMessage = _b[1];
    var timeoutRef = React.useRef(null);
    React.useEffect(function () { return function () {
        if (timeoutRef.current !== null) {
            window.clearTimeout(timeoutRef.current);
        }
    }; }, []);
    var value = [
        message !== null && message.contextKey === loadHistoryContextKey() ? message : null,
        function (message) {
            var _a;
            if (timeoutRef.current !== null) {
                window.clearTimeout(timeoutRef.current);
            }
            var contextKey = String(Math.random());
            history.replaceState({ flashMessageContextKey: contextKey }, '');
            setMessage(__assign(__assign({ subtext: null, type: (_a = message.type) !== null && _a !== void 0 ? _a : null }, message), { contextKey: contextKey }));
            timeoutRef.current = window.setTimeout(function () {
                setMessage(null);
            }, 5000);
        },
    ];
    return <Context.Provider value={value}>{children}</Context.Provider>;
};
FlashMessageProvider.displayName = 'FlashMessageProvider';
export var FlashMessageConsumer = function (_a) {
    var children = _a.children;
    return <Context.Consumer>{function (_a) {
        var message = _a[0];
        return (message !== null ? <>{children(message)}</> : null);
    }}</Context.Consumer>;
};
FlashMessageConsumer.displayName = 'FlashMessageConsumer';
export var useFlashMessage = function () { return React.useContext(Context); };
